<template>
  <v-container fluid class="py-0 px-2">
    <v-text-field
      v-model="search"
      background-color="colorSearchSettings"
      clearable
      :append-icon="mdiMagnify"
      :label="$t('label.search')"
      hide-details
    ></v-text-field>
    <div style="min-height: 1px"></div>
    <v-data-table
      :headers="headers"
      :items="tableData"
      item-key="id"
      :height="$store.state.windowSize.y - 150"
      :search="search"
      fixed-header
      must-sort
      disable-pagination
      hide-default-footer
      class="tableCursor"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.name }}</td>
          <td>{{ item.typeName }}</td>
          <td
            v-if="$store.state.auth.userSettings.accTemplates.update"
            class="px-2 tableSelectCursor"
            @click="((dialogEdit = true), (template = { ...item }))"
          >
            <v-icon>{{ mdiPen }}</v-icon>
          </td>
          <td v-else></td>
        </tr>
      </template>
    </v-data-table>
    <v-row>
      <v-col cols="3">
        <v-btn v-if="$store.state.auth.userSettings.accTemplates.write" block color="colorNew" @click="dataNew">
          {{ $t('label.addNew') }}
        </v-btn>
      </v-col>
      <v-spacer />
    </v-row>
    <!----------DIALOGS------------------------------>
    <v-dialog v-model="dialogEdit" fullscreen>
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $tc('label.printTemplate') }}
          <v-spacer />
          <v-icon large @click="dialogEdit = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text class="pa-3">
          <v-form v-model="validForm" ref="templateForm">
            <v-row>
              <v-col cols="5">
                <v-text-field
                  :label="$t('label.itemName')"
                  v-model="template.name"
                  maxlength="256"
                  :rules="[ruleRequired]"
                  hide-details
                  dense
                  required
                />
              </v-col>
              <v-col cols="3">
                <v-select
                  v-model="template.type"
                  :label="$t('label.type')"
                  :items="templateTypes"
                  item-text="text"
                  item-value="value"
                  :rules="[ruleRequired]"
                  :disabled="template.id !== 0"
                  :menu-props="{ minWidth: '500' }"
                  hide-details
                  dense
                />
              </v-col>
              <v-col cols="2">
                <v-select
                  v-model="template.header"
                  :label="$t('label.pageHeader')"
                  :items="listTemplatesHeader"
                  item-text="name"
                  item-value="id"
                  :disabled="template.type == 'header' || template.type == 'footer'"
                  :menu-props="{ minWidth: '500' }"
                  hide-details
                  clearable
                  dense
                />
              </v-col>
              <v-col cols="2">
                <v-select
                  v-model="template.footer"
                  :label="$t('label.pageFooter')"
                  :items="listTemplatesFooter"
                  item-text="name"
                  item-value="id"
                  :disabled="template.type == 'header' || template.type == 'footer'"
                  :menu-props="{ minWidth: '500' }"
                  hide-details
                  clearable
                  dense
                />
              </v-col>
            </v-row>
            <v-row v-if="template.type != 'header' && template.type != 'footer'">
              <v-col class="py-0" cols="1">
                <v-select
                  v-model="template.pageSize"
                  :label="$t('label.pageSize')"
                  :items="pageSizeList"
                  item-text="text"
                  item-value="value"
                  hide-details
                  dense
                />
              </v-col>
              <v-col class="py-0" cols="2">
                <v-select
                  v-model="template.orientation"
                  :label="$t('label.pageOrientation')"
                  :items="orientationList"
                  item-text="text"
                  item-value="value"
                  hide-details
                  dense
                />
              </v-col>
              <v-col class="py-0" cols="1">
                <v-text-field v-model.number="template.mLeft" type="number" :label="$t('label.marginLeft')" hide-details dense />
              </v-col>
              <v-col class="py-0" cols="1">
                <v-text-field v-model.number="template.mRight" type="number" :label="$t('label.marginRight')" hide-details dense />
              </v-col>
              <v-col class="py-0" cols="1">
                <v-text-field v-model.number="template.mTop" type="number" :label="$t('label.marginTop')" hide-details dense />
              </v-col>
              <v-col class="py-0" cols="1">
                <v-text-field v-model.number="template.mBottom" type="number" :label="$t('label.marginBottom')" hide-details dense />
              </v-col>
              <v-col class="py-0" cols="1">
                <v-text-field v-model.number="template.zoom" type="number" :label="$t('label.zoom')" hide-details dense />
              </v-col>
              <v-col class="py-0" cols="1">
                <v-text-field v-model.number="template.dpi" type="number" :label="$t('label.dpi')" hide-details dense />
              </v-col>
              <v-col class="py-0" cols="1">
                <v-checkbox v-model="template.grayscale" :label="$t('label.pageBlackWhite')" hide-details dense />
              </v-col>
              <v-col class="py-0" cols="2">
                <v-text-field
                  :disabled="template.type != 'areaDocument'"
                  v-model.number="template.validDays"
                  :label="$t('label.validDays')"
                  type="number"
                  min="0"
                  hide-details
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-sheet
                  :height="`${
                    template.type == 'header' || template.type == 'footer'
                      ? $store.state.windowSize.y - 200
                      : $store.state.windowSize.y - 248
                  }px`"
                  style="overflow-y: scroll"
                >
                  <codemirror
                    v-if="dialogEdit"
                    ref="templateEditor"
                    v-model="template.template"
                    :options="{
                      tabSize: 2,
                      mode: 'text/html',
                      theme: 'default',
                      lineNumbers: true,
                      line: true,
                      border: true,
                    }"
                    @ready="templateLoad"
                  />
                </v-sheet>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn
            v-if="template.id && $store.state.auth.userSettings.accTemplates.delete && template.type !== 'system'"
            color="colorDelete"
            @click="dialogDelete = true"
          >
            {{ $t('btn.delete') }}
          </v-btn>
          <v-spacer />
          <v-btn color="colorSave" @click="dataSave">{{ $t('btn.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogConfirmDelete
      :header="$t('label.delete')"
      :body="`${$t('msg.confirmDelete')}: ${template.name}?`"
      :openDialog.sync="dialogDelete"
      v-on:confirm="dataDelete"
    />
    <v-snackbar v-model="saveSnack" :timeout="2000" top color="green">{{ $t('label.saved') }}</v-snackbar>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/neat.css';
import 'codemirror/mode/htmlmixed/htmlmixed.js';
import DialogConfirmDelete from '@/components/DialogConfirmDelete.vue';

import { mdiMagnify, mdiPen, mdiClose, mdiExport, mdiImport } from '@mdi/js';

export default Vue.extend({
  name: 'SettingsTemplates',
  components: { DialogConfirmDelete, codemirror },
  data: () => ({
    dialogEdit: false,
    dialogDelete: false,
    validForm: false,
    tableData: [],
    listTemplatesHeader: [],
    listTemplatesFooter: [],
    search: '',
    template: {
      id: 0,
      name: '',
      type: '',
      template: '',
      header: 0,
      footer: 0,
      dpi: 300,
      zoom: 1,
      pageSize: 'A4',
      orientation: 'Portrait',
      grayscale: false,
      mLeft: 15,
      mRight: 15,
      mTop: 20,
      mBottom: 20,
      validDays: 0, // uplatnuje sa pri areaDocument pre platnost
    },
    saveSnack: false,
    mdiMagnify: mdiMagnify,
    mdiPen: mdiPen,
    mdiClose: mdiClose,
    mdiExport: mdiExport,
    mdiImport: mdiImport,
  }),
  computed: {
    ruleRequired() {
      return (v: any) => !!v || this.$i18n.t('msg.fieldIsMandatory');
    },
    headers: function () {
      var headers: any = [
        { text: this.$i18n.tc('label.itemName'), value: 'name', width: '300px' },
        { text: this.$i18n.tc('label.category'), value: 'type', width: '450px' },
        { sortable: false, width: '48px' },
      ];
      return headers;
    },
    pageSizeList: function () {
      var pageSizeList: any = [
        { text: this.$i18n.tc('label.A4'), value: 'A4' },
        { text: this.$i18n.tc('label.A5'), value: 'A5' },
        { text: this.$i18n.tc('label.letter'), value: 'Letter' },
      ];
      return pageSizeList;
    },
    templateTypes: function () {
      var templateTypes: any = [
        { text: this.$i18n.tc('label.visitorTicket'), value: 'visitorCard' },
        { text: this.$i18n.tc('label.dailyVisits'), value: 'currentTransactions', disabled: false },
        { text: this.$i18n.tc('label.archive'), value: 'archive' },
        { text: this.$i18n.tc('label.areaDocument'), value: 'areaDocument' },
        { text: this.$i18n.tc('label.pageHeader'), value: 'header' },
        { text: this.$i18n.tc('label.pageFooter'), value: 'footer' },
        { text: this.$i18n.tc('label.edoklady'), value: 'edoklady', disabled: false },
      ];
      return templateTypes;
    },
    orientationList: function () {
      var orientationList: any = [
        { text: this.$i18n.tc('label.portrait'), value: 'Portrait' },
        { text: this.$i18n.tc('label.landscape'), value: 'Landscape' },
      ];
      return orientationList;
    },
  },
  mounted() {
    this.dataLoad();
  },
  methods: {
    dataLoad() {
      axios
        .get('/api/v1/template')
        .then((response) => {
          this.tableData = response.data;
          for (const item of this.tableData) {
            item.typeName = this.templateTypes.find((type: any) => type.value === item.type).text;
            if (item.type == 'header') {
              this.listTemplatesHeader.push(item);
            } else if (item.type == 'footer') {
              this.listTemplatesFooter.push(item);
            }
          }
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    templateLoad() {
      if (!this.template.id) {
        setTimeout(() => {
          // Ak sa codemirror on load nerefreshne tak line numbers prekryvaju text
          // refresh musi prejst zo spozdenim a nexttick nefunguje takze settimeout
          this.template.template = '<!DOCTYPE html>\r\n<html>\r\n  <body>\r\n\r\n  </body>\r\n</html>\r\n';
          const form: any = this.$refs.templateEditor;
          form.refresh();
        }, 400);
        return;
      }
      axios
        .get(`/api/v1/template/${this.template.id}`)
        .then((response) => {
          this.template = response.data;
          setTimeout(() => {
            const form: any = this.$refs.templateEditor;
            form.refresh();
          }, 800);
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    dataNew() {
      const getDefaults: any = this.$options;
      this.template = { ...getDefaults.data().template };
      this.dialogEdit = true;
      this.$nextTick(() => {
        const form: any = this.$refs.templateForm;
        form.validate();
      });
    },
    dataSave() {
      const form: any = this.$refs.templateForm;
      if (form.validate() !== true) {
        this.$store.commit('globalMessage', this.$i18n.t('msg.formNotValid'));
      } else {
        if (this.template.id === 0) {
          axios
            .post('/api/v1/template', this.template)
            .then(() => {
              this.dataLoad();
              this.dialogEdit = false;
            })
            .catch((err) => {
              if (err.response.status === 409 && err.response.data.message === 'recordExists') {
                this.$store.commit('globalMessage', this.$i18n.t('msg.itemNameExists'));
                return;
              }
              this.$store.dispatch('catchErrHandler', err);
            });
        } else {
          axios
            .put('/api/v1/template', this.template)
            .then(() => {
              this.dataLoad();
              this.saveSnack = true;
            })
            .catch((err) => {
              if (err.response.status === 409 && err.response.data.message === 'recordExists') {
                this.$store.commit('globalMessage', this.$i18n.t('msg.itemNameExists'));
                return;
              }
              this.$store.dispatch('catchErrHandler', err);
            });
        }
      }
    },
    dataDelete() {
      axios
        .delete(`/api/v1/template/${this.template.id}`)
        .then(() => {
          this.dataLoad();
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
      this.dialogDelete = false;
      this.dialogEdit = false;
    },
  },
});
</script>

<style>
.CodeMirror {
  height: auto !important;
}
</style>
